import { retry } from "@swo/shared";

const SIMPLE_RETRY_POLICY = {
  delayMs: 500,
  count: 3,
};

export function simpleRetry<T>(eff: () => Promise<T>) {
  return retry(eff, SIMPLE_RETRY_POLICY);
}
